import React from 'react';
import withStyles from "@material-ui/core/styles/withStyles";
import {Box} from '@material-ui/core';
import style from "assets/jss/components/spinnerStyle";

type SpinnerProps = {
  classes?: any,
}

type SpinnerState = {}

class Spinner extends React.Component<SpinnerProps, SpinnerState> 
{
  render() {

    const {classes} = this.props;

    return (
      <Box className={ classes.container }>
        <Box className={ classes.loader }>
          <label>Loading...</label>
          <div style={{height:"64px",width:"64px",marginTop:"20px",background:"url(/285.gif) no-repeat"}}></div>
        </Box>
    </Box>
    );
  }
}

export default withStyles(style)(Spinner);